import OrderExecutorEditStrategy from "@/domain/OrderExecutorEditStrategy";

export const Disabled = new OrderExecutorEditStrategy(0, 'Без редактирования')
export const All = new OrderExecutorEditStrategy(1, 'Полное редактирование')
export const ItemQuantityToLowerValueOnly = new OrderExecutorEditStrategy(2, 'Только количество и в меньшую сторону')